import React from 'react';

export default class PhoneIcon extends React.Component {
    render() {
        return (
            <svg width="80" height="80" viewBox="0 0 82 82" version="1.1">
                <g transform="translate(1, 1)" stroke="none" fillRule="evenodd" >
                    <path d="M40,79 C61.5391052,79 79,61.5391052 79,40 C79,18.4608948 61.5391052,1 40,1 C18.4608948,1 1,18.4608948 1,40 C1,61.5391052 18.4608948,79 40,79 Z M40,80 C17.90861,80 0,62.09139 0,40 C0,17.90861 17.90861,0 40,0 C62.09139,0 80,17.90861 80,40 C80,62.09139 62.09139,80 40,80 Z" fillOpacity="0.5" fillRule="nonzero"></path>
                    <path d="M40,79 C61.5391052,79 79,61.5391052 79,40 C79,18.4608948 61.5391052,1 40,1 C18.4608948,1 1,18.4608948 1,40 C1,61.5391052 18.4608948,79 40,79 Z"></path>
                    <path d="M29.3831464,25 L37.0400121,32.6545455 L33.6207942,36.0727273 L43.3419218,45.7909091 L46.7611397,42.3727273 L55,50.6181818 L53.0448621,52.5727273 C49.8075174,55.8090909 44.5604729,55.8090909 41.3231282,52.5727273 L27.4280085,38.6818182 C24.1906638,35.4454545 24.1906638,30.1909091 27.4280085,26.9545455 L29.3831464,25 Z"></path>
                </g>
            </svg>
        );
    }
}